(function () {
  if (window.__lumenStore) return;
  window.__lumenStore = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var busy = false;
  var queued = false;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function markStore() {
    document.documentElement.classList.add("lumen-store");
    if (reduce) document.documentElement.classList.add("lumen-reduce");
    if ((location.pathname || "").indexOf("/policies/") === 0) {
      document.documentElement.classList.add("lumen-page");
    }
  }

  var POLICIES = {
    "refund-policy":
      "<p>Email <a href=\"mailto:valrellasupport@gmail.com\">valrellasupport@gmail.com</a> with your order number. A person reads it.</p>" +
      "<p>Unused tools: 14 days from delivery, refunded to the card you paid with. We do not publish a street address. If we actually need the item back, we will email you. A lot of refunds are done without you posting anything.</p>" +
      "<p>Change of mind: you cover postage if a return is needed.<br>Faulty or wrong item: we make that right.</p>" +
      "<p>Valrella tools are beauty accessories, not medical devices.</p>",
    "shipping-policy":
      "<p>We ship to the United Kingdom, the United States, Australia, and Canada. We do not ship worldwide, and we do not ship to the rest of Europe.</p>" +
      "<p>One standard shipping option: <strong>$6.95</strong>.</p>" +
      "<p>We pack in <strong>1–2 business days</strong>. After we pack, delivery is usually <strong>10–25 days</strong>. These are averages — customs or local post can add a few days.</p>" +
      "<p>Checkout only offers an address we deliver to. Tracking is sent when the carrier gives us a number.</p>",
    "privacy-policy":
      "<p>We use your name, email, shipping address and payment details only to take and send your order, and to reply if you write to <a href=\"mailto:valrellasupport@gmail.com\">valrellasupport@gmail.com</a>.</p>" +
      "<p>Checkout and payments run through Shopify. We do not sell your details.</p>" +
      "<p>To see or change what we hold, email <a href=\"mailto:valrellasupport@gmail.com\">valrellasupport@gmail.com</a>.</p>",
    "contact-information":
      "<p>Email <a href=\"mailto:valrellasupport@gmail.com\">valrellasupport@gmail.com</a>. A person reads it.</p>" +
      "<p>We do not publish a street address. Refunds and order questions go through that inbox only.</p>",
    "terms-of-service":
      "<p>Valrella sells beauty tools for at-home routines. They are not medical devices, and we do not make medical claims.</p>" +
      "<p>By placing an order you agree to the prices and shipping shown at checkout. Refunds follow our <a href=\"/policies/refund-policy\">refund policy</a>.</p>" +
      "<p>Questions: <a href=\"mailto:valrellasupport@gmail.com\">valrellasupport@gmail.com</a>.</p>"
  };

  function paintPolicies() {
    var parts = (location.pathname || "").split("/").filter(Boolean);
    if (parts[0] !== "policies" || !parts[1]) return;
    var html = POLICIES[parts[1]];
    if (!html) return;
    var titles = {
      "shipping-policy": "Shipping",
      "refund-policy": "Refunds",
      "privacy-policy": "Privacy",
      "contact-information": "Contact",
      "terms-of-service": "Terms of service"
    };
    if (titles[parts[1]] && document.title.indexOf(titles[parts[1]]) !== 0) {
      document.title = titles[parts[1]] + " – Valrella";
    }
    var hs = document.querySelectorAll(".shopify-policy__title h1, #MainContent h1");
    for (var t = 0; t < hs.length; t++) {
      if (titles[parts[1]] && hs[t].textContent !== titles[parts[1]]) {
        hs[t].textContent = titles[parts[1]];
      }
    }
    var nodes = document.querySelectorAll(
      ".shopify-policy__body .rte, .shopify-policy__body, .shopify-policy__container .rte, #MainContent .rte"
    );
    for (var i = 0; i < nodes.length; i++) {
      var body = nodes[i];
      if (body.dataset.lumenPolicy === "1") continue;
      var styles = body.querySelectorAll("style");
      for (var s = 0; s < styles.length; s++) styles[s].remove();
      body.dataset.lumenPolicy = "1";
      body.innerHTML = html;
    }
  }

  function isHomePage() {
    var path = (location.pathname || "/").replace(/\/+$/, "") || "/";
    return path === "/" || path === "";
  }

  var GUA_HERO_FALLBACK =
    "https://cdn.shopify.com/s/files/1/0952/8705/0621/files/tool-gua_cc766cbd-5101-45c6-b7b2-4ffef9bcab38.jpg?v=1789159062";

  var HERO_COPY = {
    headline: "Ten steps? Absolutely not.",
    support:
      "Face, hair, makeup. Five minutes on the sofa. Heat, light, or cold — then you're glowing.",
    primary: "Shop the fun ones",
    secondary: "Browse all tools"
  };

  function heroCutoutSrc() {
    var nodes = document.querySelectorAll(
      'script[src*="lumen-store"], link[href*="lumen-atelier"], link[href*="lumen-brand"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var url = nodes[i].src || nodes[i].href || "";
      var cut = url.split("?")[0];
      var idx = cut.lastIndexOf("/assets/");
      if (idx !== -1) return cut.slice(0, idx + 8) + "lumen-hero-gua.png?v=20260912";
    }
    return "/cdn/shop/t/1/assets/lumen-hero-gua.png?v=20260912";
  }

  /** Premium beauty homepage hero: complete Gua Sha, no giant logo. */
  function mountHomeHero() {
    if (!isHomePage()) return;
    var root = document.documentElement;
    root.classList.add("lumen-home-hero");

    var hero =
      document.querySelector(".hero-wrapper .hero") ||
      document.querySelector(".shopify-section.hero-wrapper .hero") ||
      document.querySelector(".hero");
    if (!hero) return;

    polishHeroCopy(hero);

    var media =
      hero.querySelector(".hero__media-grid") ||
      hero.querySelector('[data-testid="hero-media-wrapper"]') ||
      hero.querySelector(".hero__media-wrapper");
    if (!media) return;
    if (hero.dataset.lumenHeroMounted === "1") {
      var existing = media.querySelector("a.lumen-hero__visual");
      if (existing) {
        bindHeroPicks(
          existing,
          existing.querySelector("img.lumen-hero__product"),
          existing.querySelector(".lumen-hero__caption")
        );
      }
      return;
    }
    hero.dataset.lumenHeroMounted = "1";

    var svgs = media.querySelectorAll("svg.hero__media, svg");
    for (var s = 0; s < svgs.length; s++) {
      svgs[s].setAttribute("aria-hidden", "true");
      svgs[s].style.setProperty("display", "none", "important");
    }

    var wrap = media.querySelector("a.lumen-hero__visual");
    if (!wrap) {
      wrap = document.createElement("a");
      wrap.className = "lumen-hero__visual";
      wrap.href = "/products/tool-gua";
      wrap.setAttribute("aria-label", "Electric Gua Sha Massager");
      media.appendChild(wrap);
    }

    var img = wrap.querySelector("img.lumen-hero__product");
    if (!img) {
      img = document.createElement("img");
      img.className = "lumen-hero__product";
      img.alt = "Electric Gua Sha Massager";
      img.decoding = "async";
      img.loading = "eager";
      try {
        img.fetchPriority = "high";
      } catch (e) {}
      wrap.appendChild(img);
    }

    var cutout = heroCutoutSrc();
    img.src = cutout;
    img.onerror = function () {
      if (img.dataset.lumenHeroFb === "1") return;
      img.dataset.lumenHeroFb = "1";
      img.src = withWidth(GUA_HERO_FALLBACK, 1400);
    };

    var cap = wrap.querySelector(".lumen-hero__caption");
    if (!cap) {
      cap = document.createElement("span");
      cap.className = "lumen-hero__caption";
      cap.textContent = "ELECTRIC GUA SHA MASSAGER";
      wrap.appendChild(cap);
    }

    bindHeroPicks(wrap, img, cap);
  }

  function showHeroProduct(wrap, img, cap, pick) {
    if (!wrap || !img || !pick) return;
    var href = pick.getAttribute("href") || "";
    var title = pick.getAttribute("data-hero-title") || "";
    var image = pick.getAttribute("data-hero-image") || "";
    var handle = pick.getAttribute("data-hero-handle") || "";
    if (href) wrap.href = href;
    if (title) {
      wrap.setAttribute("aria-label", title);
      img.alt = title;
      if (cap) cap.textContent = title.toUpperCase();
    }
    if (handle === "tool-gua") {
      img.src = heroCutoutSrc();
      img.dataset.lumenHeroFb = "";
    } else if (image) {
      img.src = image;
    }
    var all = document.querySelectorAll("[data-hero-pick]");
    for (var i = 0; i < all.length; i++) {
      all[i].classList.toggle("is-active", all[i] === pick);
    }
  }

  function bindHeroPicks(wrap, img, cap) {
    var picks = document.querySelectorAll("[data-hero-pick]");
    for (var i = 0; i < picks.length; i++) {
      if (picks[i].dataset.lumenHeroBound === "1") continue;
      picks[i].dataset.lumenHeroBound = "1";
      picks[i].addEventListener("mouseenter", function () {
        showHeroProduct(wrap, img, cap, this);
      });
      picks[i].addEventListener("focus", function () {
        showHeroProduct(wrap, img, cap, this);
      });
    }
  }

  function polishHeroCopy(hero) {
    var block = hero.querySelector(".text-block, rte-formatter");
    if (!block) return;
    var h1 = block.querySelector("h1");
    var ps = block.querySelectorAll("p");
    // Theme JSON owns the copy. Only rescue a leftover shop-name heading.
    if (h1 && /^\s*(LUMEN|NYLORIE|Nylorie|VALRELLA|Valrella)\s*$/i.test((h1.textContent || "").trim())) {
      var headline = ps[0] ? ps[0].textContent : HERO_COPY.headline;
      h1.textContent = headline || HERO_COPY.headline;
      if (ps[0] && headline) ps[0].remove();
    }
  }

  function isShopifyImg(url) {
    return (
      !!url &&
      (url.indexOf("cdn.shopify.com") !== -1 ||
        url.indexOf("/cdn/shop/") !== -1)
    );
  }

  function stripSizeParams(url) {
    var clean = String(url || "").split(" ")[0];
    clean = clean
      .replace(/([?&])width=\d+/g, "")
      .replace(/([?&])height=\d+/g, "")
      .replace(/\?&/, "?")
      .replace(/&&/g, "&")
      .replace(/[?&]$/, "");
    return clean;
  }

  function withWidth(url, w) {
    var clean = stripSizeParams(url);
    if (!clean) return url;
    return clean + (clean.indexOf("?") === -1 ? "?" : "&") + "width=" + w;
  }

  function readWidth(url) {
    var m = String(url || "").match(/[?&]width=(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  /** Crisp visible cards, capped offscreen decode — no fade, no scroll thrash. */
  function sharpenImages() {
    var dpr = window.devicePixelRatio || 1;
    var imgs = document.querySelectorAll(
      ".product-card img, .card-gallery img, .resource-card img, .product-grid img"
    );
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.closest("media-gallery")) return;
        var src = img.currentSrc || img.getAttribute("src") || "";
        if (!isShopifyImg(src)) return;

        var slide = img.closest("slideshow-slide, .product-media-container");
        var hidden =
          (slide &&
            (slide.getAttribute("aria-hidden") === "true" ||
              slide.style.display === "none")) ||
          img.clientWidth === 0;

        // Visible: 2x CSS size, min 1200, max 2000. Hidden: 900 (never 3840).
        var want = hidden
          ? 900
          : Math.min(
              2000,
              Math.max(1200, Math.ceil((img.clientWidth || 450) * dpr * 2))
            );

        var curW = readWidth(src);
        var soft =
          !hidden &&
          img.naturalWidth > 0 &&
          img.clientWidth > 0 &&
          img.naturalWidth < img.clientWidth * dpr * 0.95;

        if (img.dataset.lumenHi === String(want) && !soft) return;

        img.loading = hidden ? "lazy" : "eager";
        img.decoding = "async";
        if (!hidden) {
          try {
            img.fetchPriority = "high";
          } catch (e) {}
        }
        img.removeAttribute("srcset");
        img.sizes = hidden
          ? "100vw"
          : Math.ceil((img.clientWidth || 450) * dpr) + "px";

        var next = withWidth(src, want);
        if (curW === want && !soft) {
          img.dataset.lumenHi = String(want);
          return;
        }

        // Prefetch then swap — avoids blank flash / lag
        var pre = new Image();
        pre.decoding = "async";
        pre.onload = function () {
          if (img.getAttribute("src") !== next) img.setAttribute("src", next);
          img.dataset.lumenHi = String(want);
        };
        pre.onerror = function () {
          img.dataset.lumenHi = String(want);
        };
        pre.src = next;
      })(imgs[i]);
    }
  }

  function softImages() {
    // No fade-in on product photos
  }

  function revealCards() {
    var nodes = document.querySelectorAll(
      ".product-card, .product-card-wrapper, .resource-card, .card-wrapper"
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.lumenReveal === "1") continue;
      el.dataset.lumenReveal = "1";
      el.classList.add("lumen-reveal", "is-in");
      el.style.opacity = "1";
      el.style.visibility = "visible";
      el.style.animation = "none";
    }
  }

  function polishButtons() {
    var buttons = document.querySelectorAll(
      "button[name='add'], .quick-add__button, .product-form__submit"
    );
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      if (b.dataset.lumenBtn === "1") continue;
      b.dataset.lumenBtn = "1";
      b.classList.add("lumen-cta");
    }
  }

  function hidePoliciesChrome() {
    var nodes = document.querySelectorAll(
      ".policy-list-trigger, button.policy-list-trigger, .terms-policies-popover, #terms-policies-popover, footer-policy-list, [class*='policy-list'], [class*='terms-policies']"
    );
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.closest("[id*='__footer'] .text-block")) continue;
      n.style.setProperty("display", "none", "important");
      n.style.setProperty("visibility", "hidden", "important");
      n.setAttribute("hidden", "");
      n.setAttribute("aria-hidden", "true");
    }
    var all = document.querySelectorAll("button, a, [role='button']");
    for (var j = 0; j < all.length; j++) {
      var t = (all[j].textContent || "").replace(/\s+/g, " ").trim();
      if (/terms and policies|^policies$/i.test(t)) {
        all[j].style.setProperty("display", "none", "important");
        all[j].setAttribute("hidden", "");
        all[j].setAttribute("aria-hidden", "true");
      }
    }
  }

  function hideEmptyReviews() {
    var empty = document.querySelectorAll(".lm-reviews__empty");
    for (var i = 0; i < empty.length; i++) {
      var section = empty[i].closest(".shopify-section") || empty[i];
      section.style.setProperty("display", "none", "important");
      section.setAttribute("hidden", "");
      section.setAttribute("aria-hidden", "true");
    }
  }

  function polishAnnouncement() {
    var bars = document.querySelectorAll(
      "[class*=announcement], .announcement-bar, .header-announcements"
    );
    for (var i = 0; i < bars.length; i++) {
      bars[i].classList.add("lumen-announce");
    }
  }

  function polishShopName() {
    var brand = /^(LUMEN|NYLORIE|Nylorie)$/i;
    var title = document.title || "";
    if (/\b(LUMEN|NYLORIE|Nylorie)\b/i.test(title)) {
      document.title = title.replace(/\b(LUMEN|NYLORIE|Nylorie)\b/gi, "Valrella");
    }
    if (/Premium at-home beauty tools/i.test(document.title)) {
      document.title = "Valrella";
    }
    var nodes = document.querySelectorAll(
      '.header a[href="/"], .header__heading-link, .header-logo, footer a[href="/"], .product-vendor, [class*="product-vendor"], [class*="vendor"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector("img")) continue;
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (brand.test(t)) el.textContent = "Valrella";
    }
  }

  function hideWarehouseSkus() {
    var code = /^(TOOL|KIT)_[A-Z0-9_]+$/;
    var nodes = document.querySelectorAll(
      ".product-sku, .sku, .cart-item__sku, [class*='sku'], .product-details span, .product-details p"
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!code.test(t)) continue;
      el.style.setProperty("display", "none", "important");
      el.setAttribute("hidden", "");
    }
  }

  function fixMobileMenu() {
    var selectors =
      ".menu-drawer__menu-item, .menu-drawer__menu-item-text, .header__menu-item, .header-menu__item, .menu-drawer summary, [role=presentation], .menu-drawer__list-item";
    var items = document.querySelectorAll(selectors);
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!/^more$/i.test(t)) continue;
      var row =
        el.closest(".menu-drawer__menu-item, .header__menu-item, li, details") ||
        el;
      row.style.display = "none";
    }
  }

  function fixMobileDrawer() {
    var open = document.querySelector("details.menu-drawer-container[open]");
    if (!open) return;
    var drawer = open.querySelector(".menu-drawer");
    if (!drawer) return;
    open.style.setProperty("position", "fixed", "important");
    open.style.setProperty("inset", "0", "important");
    open.style.setProperty("width", "100%", "important");
    open.style.setProperty("max-width", "100%", "important");
    open.style.setProperty("height", "100%", "important");
    open.style.setProperty("z-index", "95", "important");
    drawer.style.setProperty("width", "100vw", "important");
    drawer.style.setProperty("max-width", "100vw", "important");
    drawer.style.setProperty("min-width", "100vw", "important");
    drawer.style.setProperty("transform", "translateX(0)", "important");
    drawer.style.setProperty("left", "0", "important");
    drawer.style.setProperty("right", "0", "important");
    var links = drawer.querySelectorAll("a.menu-drawer__menu-item");
    for (var i = 0; i < links.length; i++) {
      links[i].style.setProperty("width", "100%", "important");
      links[i].style.setProperty("min-height", "48px", "important");
    }
  }

  function watchDrawer() {
    document.addEventListener(
      "toggle",
      function (ev) {
        if (!ev.target || !ev.target.classList) return;
        if (!ev.target.classList.contains("menu-drawer-container")) return;
        setTimeout(function () {
          fixMobileDrawer();
          fixMobileMenu();
          syncChrome();
        }, 30);
      },
      true
    );
  }

  function syncChrome() {
    var open =
      document.querySelector(
        "cart-drawer[open], cart-drawer details[open], .menu-drawer.menu-open, details[open] .menu-drawer, dialog[open]"
      ) != null;
    document.documentElement.classList.toggle("lumen-chrome-open", open);
  }

  function watchChrome() {
    syncChrome();
    document.addEventListener("click", function () {
      setTimeout(syncChrome, 60);
      setTimeout(syncChrome, 320);
    }, true);
    document.addEventListener("shopify:section:load", syncChrome);
  }

  /* /collections/all is Shopify's built-in list, so its title is the generic
     "Products". Give it a name that reads like the rest of the store. */
  function polishCatalogTitle() {
    if (document.querySelector("[data-lumen-shop-hero]")) return;
    if (location.pathname.replace(/\/$/, "") !== "/collections/all") return;
    var h1 = document.querySelector("main h1, #MainContent h1");
    if (!h1 || h1.dataset.lumenTitle === "1") return;
    if ((h1.textContent || "").trim() !== "Products") return;
    h1.dataset.lumenTitle = "1";
    h1.textContent = "All tools";
  }

  var SHOP_NOTES = {
    "tool-gua": "Warm massage",
    "tool-led": "Hands-free glow",
    "tool-ice-roller": "Cold mornings",
    "tool-ice-globes": "Ice on tap",
    "tool-roller": "Slow roll",
    "tool-eye-wand": "Spot of light",
    "tool-mirror": "Lit makeup",
    "tool-scalp-comb": "Scalp session",
    "tool-scalp": "Sleep in it",
    "tool-steamer": "Soft mist",
    "tool-pore": "Clear the day",
    "tool-derma": "Tiny stamp",
    "tool-brow": "Clean arch",
    "tool-lash": "Quick curl",
    "tool-sponges": "Blend kit",
    "tool-brush": "Soft sweep",
    "kit-glow-tools": "Starter set",
    "kit-stone": "Roll + gua"
  };
  var SHOP_CHIPS = {
    all: null,
    heat: ["tool-gua", "tool-eye-wand", "tool-steamer", "tool-pore", "tool-derma"],
    light: ["tool-led", "tool-mirror"],
    cold: ["tool-ice-roller", "tool-ice-globes", "tool-roller"],
    face: [
      "tool-gua",
      "tool-led",
      "tool-roller",
      "tool-ice-roller",
      "tool-ice-globes",
      "tool-eye-wand",
      "tool-steamer",
      "tool-pore",
      "tool-derma",
      "tool-brush",
      "kit-stone"
    ],
    hair: ["tool-scalp-comb", "tool-scalp"],
    makeup: ["tool-brow", "tool-lash", "tool-sponges", "tool-mirror", "tool-brush"],
    kits: ["kit-glow-tools", "kit-stone"]
  };

  function shopHandleFromCard(item) {
    var a = item.querySelector('a[href*="/products/"]');
    if (!a) return "";
    var href = a.getAttribute("href") || "";
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  function isShopPage() {
    return /\/collections\//.test(location.pathname || "");
  }

  function shopGridItems(grid) {
    return Array.prototype.slice.call(
      grid.querySelectorAll(".product-grid__item, .resource-list__item")
    );
  }

  function applyShopChip(grid, key, countEl, chips) {
    var allow = SHOP_CHIPS[key];
    var items = shopGridItems(grid);
    var shown = 0;
    for (var i = 0; i < items.length; i++) {
      var handle = items[i].dataset.lumenHandle || shopHandleFromCard(items[i]);
      var ok = !allow || allow.indexOf(handle) !== -1;
      items[i].hidden = !ok;
      items[i].style.setProperty("display", ok ? "" : "none", "important");
      if (ok) shown += 1;
    }
    if (countEl) {
      countEl.textContent = shown + (shown === 1 ? " tool" : " tools");
    }
    for (var c = 0; c < chips.length; c++) {
      chips[c].classList.toggle("is-on", chips[c].getAttribute("data-lumen-chip") === key);
    }
  }

  function mountShopCatalog() {
    if (!isShopPage()) return;
    var grid =
      document.querySelector(".product-grid") ||
      document.querySelector(".resource-list--grid");
    if (!grid) return;

    var items = shopGridItems(grid);
    var i;
    for (i = 0; i < items.length; i++) {
      var item = items[i];
      var itemHandle = shopHandleFromCard(item);
      item.dataset.lumenHandle = itemHandle;
      var note = SHOP_NOTES[itemHandle];
      if (note && !item.querySelector(".lumen-shop-note")) {
        var p = el("p", "lumen-shop-note", note);
        var host =
          item.querySelector(".product-card__content") ||
          item.querySelector("product-card") ||
          item;
        host.appendChild(p);
      }
    }

    var countEl = document.querySelector("[data-lumen-shop-count]");
    if (countEl && !countEl.dataset.lumenFilled) {
      countEl.textContent = items.length + (items.length === 1 ? " tool" : " tools");
      countEl.dataset.lumenFilled = "1";
    }

    var h1s = document.querySelectorAll("#MainContent h1");
    for (i = 0; i < h1s.length; i++) {
      if (h1s[i].classList.contains("lm-shop-hero__title")) continue;
      var section = h1s[i].closest(".shopify-section");
      if (section && !section.querySelector(".product-grid, .lm-shop-hero")) {
        section.style.setProperty("display", "none", "important");
      }
    }

    if (grid.dataset.lumenChips === "1") return;
    grid.dataset.lumenChips = "1";
    var chipNodes = document.querySelectorAll("[data-lumen-chip]");
    for (i = 0; i < chipNodes.length; i++) {
      chipNodes[i].addEventListener("click", function (ev) {
        ev.preventDefault();
        applyShopChip(
          grid,
          this.getAttribute("data-lumen-chip") || "all",
          document.querySelector("[data-lumen-shop-count]"),
          document.querySelectorAll("[data-lumen-chip]")
        );
      });
    }
  }

  function polishViewAll() {
    var links = document.querySelectorAll("a.link, a[href*='/collections/']");
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.dataset.lumenViewAll === "1") continue;
      var t = (a.textContent || "").replace(/\s+/g, " ").trim();
      if (t.toLowerCase() !== "view all") continue;
      a.dataset.lumenViewAll = "1";
      a.classList.add("lumen-view-all");
      // The bestsellers collection is curated; View all goes to the full catalog
      if ((a.getAttribute("href") || "").indexOf("/collections/frontpage") !== -1) {
        a.setAttribute("href", "/collections/all");
      }
    }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function cardSlides(gallery) {
    var slides = gallery.querySelectorAll("slideshow-slide");
    if (slides.length >= 2) return slides;
    var medias = gallery.querySelectorAll(".product-media-container");
    if (medias.length >= 2) return medias;
    return [];
  }

  function cardShowIx(gallery, ix) {
    var slides = cardSlides(gallery);
    var n = slides.length;
    if (!n) return;
    ix = ((ix % n) + n) % n;
    gallery.dataset.lumenIx = String(ix);
    var sc = gallery.querySelector("slideshow-component");
    try {
      if (sc && typeof sc.select === "function" && sc.current !== ix) sc.select(ix);
    } catch (e) {}
    for (var j = 0; j < n; j++) {
      var on = j === ix;
      var node = slides[j];
      if (node.setAttribute) node.setAttribute("aria-hidden", on ? "false" : "true");
      if (node.style) {
        node.style.setProperty("display", on ? "block" : "none", "important");
        node.style.setProperty("visibility", on ? "visible" : "hidden", "important");
        node.style.setProperty("opacity", on ? "1" : "0", "important");
      }
    }
  }

  function mountCardArrows() {
    // No shop paints carousel arrows on grid tiles — NuFace and Magpie both
    // leave the tile clean and swap to the second shot on hover, which the
    // theme already does via the gallery's pointerenter preview.
    return;
    // eslint-disable-next-line no-unreachable
    var galleries = document.querySelectorAll(
      "product-card .card-gallery, .product-card .card-gallery, .resource-card .card-gallery, slideshow-component.card-gallery, .card-gallery"
    );
    for (var i = 0; i < galleries.length; i++) {
      (function (gallery) {
        // Only product/collection cards — skip PDP media-gallery
        if (gallery.closest("media-gallery")) return;
        if (
          !gallery.closest(
            "product-card, .product-card, .resource-card, .product-grid, .resource-list"
          )
        ) {
          return;
        }
        if (gallery.dataset.lumenCardArrows === "1") return;
        var slides = cardSlides(gallery);
        if (slides.length < 2) return;
        gallery.dataset.lumenCardArrows = "1";
        if (getComputedStyle(gallery).position === "static") {
          gallery.style.setProperty("position", "relative", "important");
        }
        // Theme only paints arrows on some cards (e.g. gua) — hide + use ours on ALL
        var themeArrows = gallery.querySelectorAll(
          "slideshow-arrows, .slideshow-control, button[aria-label='Previous slide'], button[aria-label='Next slide']"
        );
        for (var t = 0; t < themeArrows.length; t++) {
          themeArrows[t].style.setProperty("display", "none", "important");
        }
        if (gallery.dataset.lumenIx == null) gallery.dataset.lumenIx = "0";
        cardShowIx(gallery, parseInt(gallery.dataset.lumenIx || "0", 10) || 0);

        var existing = gallery.querySelector(".lumen-arrows--card");
        if (existing) existing.remove();

        var wrap = el("div", "lumen-arrows lumen-arrows--card");
        var prev = el("button", "lumen-arrows__btn lumen-arrows__btn--prev", "‹");
        prev.type = "button";
        prev.setAttribute("aria-label", "Previous image");
        var next = el("button", "lumen-arrows__btn lumen-arrows__btn--next", "›");
        next.type = "button";
        next.setAttribute("aria-label", "Next image");

        function wire(btn, dir) {
          btn.addEventListener(
            "click",
            function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
              var y = window.scrollY || window.pageYOffset || 0;
              var ix = parseInt(gallery.dataset.lumenIx || "0", 10) || 0;
              cardShowIx(gallery, ix + dir);
              sharpenImages();
              requestAnimationFrame(function () {
                window.scrollTo(0, y);
              });
              setTimeout(function () {
                window.scrollTo(0, y);
              }, 40);
            },
            true
          );
        }
        wire(prev, -1);
        wire(next, 1);
        wrap.appendChild(prev);
        wrap.appendChild(next);
        gallery.appendChild(wrap);
      })(galleries[i]);
    }
  }

  /** Clicking product photos must not jump/scroll the page. */
  function stopMediaClickScroll() {
    if (document.documentElement.dataset.lumenNoMediaScroll === "1") return;
    document.documentElement.dataset.lumenNoMediaScroll = "1";

    function lockY(ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var hit = t.closest(
        "media-gallery, .card-gallery, slideshow-component, slideshow-slide, .product-media, .lumen-arrows, .product-media-container"
      );
      if (!hit) return;
      // Don't block real product-link navigation off the card title area
      if (t.closest("a[href*='/products/']") && !t.closest(".lumen-arrows, slideshow-slide, .card-gallery, media-gallery")) {
        return;
      }
      var y = window.scrollY || window.pageYOffset || 0;
      // Kill focus-driven scrollIntoView from theme slideshow
      if (ev.type === "mousedown" || ev.type === "pointerdown") {
        if (t.blur && t !== document.body) {
          /* keep */
        }
      }
      requestAnimationFrame(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      });
      setTimeout(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      }, 0);
      setTimeout(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      }, 80);
      setTimeout(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      }, 200);
    }

    document.addEventListener("click", lockY, true);
    document.addEventListener("mousedown", lockY, true);
    document.addEventListener("pointerdown", lockY, true);
    document.addEventListener(
      "focusin",
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (!t.closest("media-gallery, .card-gallery, .lumen-arrows, slideshow-component")) return;
        var y = window.scrollY || 0;
        requestAnimationFrame(function () {
          window.scrollTo(0, y);
        });
      },
      true
    );
  }

  function watchCurrency() {
    if (!window.LumenCurrency || !window.LumenCurrency.refresh) return;
    document.addEventListener(
      "change",
      function () {
        setTimeout(function () {
          if (window.LumenCurrency && window.LumenCurrency.refresh) {
            window.LumenCurrency.refresh();
          }
        }, 400);
      },
      true
    );
  }

  /* ---------- Friendly typo help: search + 404 ---------- */
  var ALIASES = {
    gua: "tool-gua",
    guasha: "tool-gua",
    "gua sha": "tool-gua",
    gasha: "tool-gua",
    massager: "tool-gua",
    led: "tool-led",
    ledd: "tool-led",
    leed: "tool-led",
    "ledd mask": "tool-led",
    "leed mask": "tool-led",
    "led maks": "tool-led",
    mask: "tool-led",
    "face mask": "tool-led",
    "led mask": "tool-led",
    "led light": "tool-led",
    "light therapy": "tool-led",
    ice: "tool-ice-roller",
    "ice roller": "tool-ice-roller",
    roller: "tool-ice-roller",
    brush: "tool-brush",
    silicone: "tool-brush",
    steamer: "tool-steamer",
    mister: "tool-steamer",
    mist: "tool-steamer",
    pore: "tool-pore",
    blackhead: "tool-pore",
    derma: "tool-derma",
    stamp: "tool-derma",
    hydra: "tool-derma",
    scalp: "tool-scalp-comb",
    comb: "tool-scalp-comb",
    wand: "tool-eye-wand",
    contour: "tool-eye-wand",
    neck: "tool-gua",
    jaw: "tool-gua",
    stone: "kit-stone",
    jade: "kit-stone",
    gift: "kit-stone",
    glow: "kit-glow-tools",
    kit: "kit-glow-tools",
    starter: "kit-glow-tools",
    sponge: "tool-sponges",
    makeup: "tool-sponges",
    lash: "tool-lash",
    curler: "tool-lash",
    brow: "tool-brow",
    razor: "tool-brow",
    mirror: "tool-mirror",
    compact: "tool-mirror",
    curl: "tool-scalp",
    heatless: "tool-scalp",
    cryo: "tool-ice-globes",
    globe: "tool-ice-globes",
    globes: "tool-ice-globes"
  };

  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, " ")
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function lev(a, b) {
    a = norm(a);
    b = norm(b);
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var i;
    var j;
    var prev = [];
    var cur = [];
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      prev = cur.slice();
    }
    return prev[b.length];
  }

  function queryParam() {
    try {
      return new URLSearchParams(location.search).get("q") || "";
    } catch (e) {
      return "";
    }
  }

  function isSearchPage() {
    return location.pathname.indexOf("/search") === 0;
  }

  function is404Page() {
    if (document.documentElement.getAttribute("data-page-type") === "404") {
      return true;
    }
    if (document.body && document.body.getAttribute("data-page-type") === "404") {
      return true;
    }
    if (/page not found/i.test(document.title || "")) return true;
    var h1 = document.querySelector("h1");
    return !!(h1 && /page not found|404/i.test(h1.textContent || ""));
  }

  function searchResultCount() {
    var t = (document.title || "")
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, "&")
      .replace(/\s+/g, " ");
    var m = t.match(/(\d+)\s+results?\s+found/i);
    if (m) return parseInt(m[1], 10);
    // Prefer the live search heading over recommendation grids elsewhere
    var heading = document.querySelector(
      "main h1, main .search__title, main [class*='search'] h1, main .section-header"
    );
    var headingText = (heading && heading.textContent) || "";
    m = headingText.match(/(\d+)\s+results?\s+found/i);
    if (m) return parseInt(m[1], 10);
    if (/no results found/i.test(headingText)) return 0;
    var body = (document.body && document.body.innerText) || "";
    m = body.match(/(\d+)\s+results?\s+found\s+for\s+[“"']?/i);
    if (m) return parseInt(m[1], 10);
    return null;
  }

  function searchHasNoResults() {
    if (!isSearchPage()) return false;
    var count = searchResultCount();
    if (count === 0) return true;
    if (count != null && count > 0) return false;
    var heading = document.querySelector("main h1, main .search__title, main .section-header");
    var headingText = (heading && heading.textContent) || "";
    if (/no results/i.test(headingText)) return true;
    var empty = document.querySelector(
      ".search__empty, .empty-state, [data-search-empty], .predictive-search__empty"
    );
    if (empty && /no results/i.test(empty.textContent || "")) return true;
    var body = (document.body && document.body.innerText) || "";
    if (/no results found for/i.test(body)) return true;
    return false;
  }

  function looksMistyped(query, products) {
    var q = norm(query);
    if (!q || q.length < 3) return false;

    // Exact / near-exact title match → not a typo tip
    var i;
    for (i = 0; i < products.length; i++) {
      var title = norm(products[i].title);
      var handleWords = norm(String(products[i].handle || "").replace(/-/g, " "));
      if (title === q || handleWords === q) return false;
      if (title.indexOf(q) !== -1 || handleWords.indexOf(q) !== -1) return false;
      // every query word appears in the title (order-independent)
      var parts = q.split(" ");
      var allIn = true;
      var p;
      for (p = 0; p < parts.length; p++) {
        if (parts[p].length < 2) continue;
        if (title.indexOf(parts[p]) === -1 && handleWords.indexOf(parts[p]) === -1) {
          allIn = false;
          break;
        }
      }
      if (allIn && parts.length) return false;
    }

    if (ALIASES[q]) return true;
    var words = q.split(" ");
    for (i = 0; i < words.length; i++) {
      if (ALIASES[words[i]] && words[i].length >= 3) return true;
    }

    // Fuzzy: best title/word distance is small but not zero
    var best = 99;
    for (i = 0; i < products.length; i++) {
      best = Math.min(best, scoreProduct(query, products[i]));
    }
    return best > 0 && best <= 3;
  }

  function scoreProduct(query, product) {
    var q = norm(query);
    if (!q || !product) return 99;
    var title = norm(product.title);
    var handle = norm(product.handle).replace(/\s+/g, "-");
    var handleWords = norm(product.handle.replace(/-/g, " "));
    if (title === q || handleWords === q) return 0;
    if (title.indexOf(q) !== -1 || handleWords.indexOf(q) !== -1) return 1;
    if (ALIASES[q] && ALIASES[q] === product.handle) return 0.5;

    var best = lev(q, title);
    best = Math.min(best, lev(q, handleWords));
    var parts = q.split(" ");
    var titleParts = title.split(" ");
    var i;
    var j;
    for (i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.length < 2) continue;
      if (ALIASES[p] && ALIASES[p] === product.handle) {
        best = Math.min(best, 1);
      }
      for (j = 0; j < titleParts.length; j++) {
        var tp = titleParts[j];
        if (tp.length < 2) continue;
        var d = lev(p, tp);
        // short typos: ledd/led, gua/guaa
        if (d <= 1 && Math.min(p.length, tp.length) >= 3) best = Math.min(best, 1 + d);
        else if (d <= 2 && Math.min(p.length, tp.length) >= 5) best = Math.min(best, 2 + d);
      }
    }
    return best;
  }

  function loadCatalog(cb) {
    if (window.__lumenCatalog) {
      cb(window.__lumenCatalog);
      return;
    }
    fetch("/products.json?limit=250", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var list = (data && data.products) || [];
        window.__lumenCatalog = list;
        cb(list);
      })
      .catch(function () {
        cb([]);
      });
  }

  function suggestProducts(query, catalog, limit) {
    limit = limit || 4;
    var scored = [];
    var i;
    for (i = 0; i < catalog.length; i++) {
      var p = catalog[i];
      var s = scoreProduct(query, p);
      if (s <= 4) scored.push({ product: p, score: s });
    }
    // alias direct hits if query maps cleanly
    var nq = norm(query);
    if (ALIASES[nq]) {
      for (i = 0; i < catalog.length; i++) {
        if (catalog[i].handle === ALIASES[nq]) {
          scored.push({ product: catalog[i], score: 0 });
        }
      }
    }
    scored.sort(function (a, b) {
      return a.score - b.score;
    });
    var seen = {};
    var out = [];
    for (i = 0; i < scored.length; i++) {
      var h = scored[i].product.handle;
      if (seen[h]) continue;
      seen[h] = 1;
      out.push(scored[i].product);
      if (out.length >= limit) break;
    }
    return out;
  }

  function productThumb(p) {
    var img =
      (p.images && p.images[0] && p.images[0].src) ||
      (p.image && p.image.src) ||
      "";
    if (!img) return "";
    return img + (img.indexOf("?") === -1 ? "?" : "&") + "width=160";
  }

  function moneyLite(amount) {
    try {
      if (window.LumenCurrency && window.LumenCurrency.money) {
        return window.LumenCurrency.money(Number(amount));
      }
    } catch (e) {}
    return "$" + Number(amount).toFixed(2);
  }

  function renderSuggestPanel(host, query, products, mode) {
    if (!host || !products || !products.length) return;
    if (document.querySelector(".lumen-didyoumean")) return;

    var wrap = document.createElement("div");
    wrap.className = "lumen-didyoumean";
    wrap.setAttribute("role", "region");
    wrap.setAttribute("aria-label", "Suggested products");

    var title = document.createElement("p");
    title.className = "lumen-didyoumean__eyebrow";
    title.textContent = mode === "404" ? "Page not found" : "No exact match";

    var msg = document.createElement("h2");
    msg.className = "lumen-didyoumean__title";
    if (mode === "404") {
      msg.textContent = "Sorry — were you looking for one of these?";
    } else if (query) {
      msg.textContent = 'Sorry — did you mean one of these for "' + query + '"?';
    } else {
      msg.textContent = "Sorry — did you mean one of these?";
    }

    var sub = document.createElement("p");
    sub.className = "lumen-didyoumean__sub";
    sub.textContent =
      "Typing happens. Pick a glow tool below, or try another search.";

    var list = document.createElement("ul");
    list.className = "lumen-didyoumean__list";

    for (var i = 0; i < products.length; i++) {
      (function (p) {
        var li = document.createElement("li");
        li.className = "lumen-didyoumean__item";
        var a = document.createElement("a");
        a.className = "lumen-didyoumean__link";
        a.href = "/products/" + p.handle;
        var thumb = productThumb(p);
        if (thumb) {
          var img = document.createElement("img");
          img.className = "lumen-didyoumean__thumb";
          img.src = thumb;
          img.alt = p.title || "";
          img.width = 56;
          img.height = 56;
          img.loading = "lazy";
          a.appendChild(img);
        }
        var meta = document.createElement("span");
        meta.className = "lumen-didyoumean__meta";
        var name = document.createElement("span");
        name.className = "lumen-didyoumean__name";
        name.textContent = p.title;
        meta.appendChild(name);
        if (p.variants && p.variants[0]) {
          var price = document.createElement("span");
          price.className = "lumen-didyoumean__price";
          price.textContent = moneyLite(p.variants[0].price);
          meta.appendChild(price);
        }
        a.appendChild(meta);
        li.appendChild(a);
        list.appendChild(li);
      })(products[i]);
    }

    var actions = document.createElement("div");
    actions.className = "lumen-didyoumean__actions";
    var catalog = document.createElement("a");
    catalog.className = "lumen-didyoumean__btn";
    catalog.href = "/collections/all";
    catalog.textContent = "Browse all tools";
    actions.appendChild(catalog);
    if (mode !== "search") {
      var search = document.createElement("a");
      search.className = "lumen-didyoumean__btn lumen-didyoumean__btn--ghost";
      search.href = "/search";
      search.textContent = "Search again";
      actions.appendChild(search);
    }

    wrap.appendChild(title);
    wrap.appendChild(msg);
    wrap.appendChild(sub);
    wrap.appendChild(list);
    wrap.appendChild(actions);
    host.appendChild(wrap);
  }

  function renderDidYouMeanBar(host, query, products) {
    if (!host || !products || !products.length) return;
    if (document.querySelector(".lumen-didyoumean, .lumen-didyoumean-bar")) return;

    var top = products[0];
    var wrap = document.createElement("div");
    wrap.className = "lumen-didyoumean-bar";
    wrap.setAttribute("role", "status");

    var lead = document.createElement("p");
    lead.className = "lumen-didyoumean-bar__text";
    lead.appendChild(document.createTextNode("Sorry — did you mean "));
    var link = document.createElement("a");
    link.className = "lumen-didyoumean-bar__link";
    link.href = "/products/" + top.handle;
    link.textContent = top.title;
    lead.appendChild(link);
    if (query) {
      lead.appendChild(document.createTextNode(' instead of "' + query + '"?'));
    } else {
      lead.appendChild(document.createTextNode("?"));
    }
    wrap.appendChild(lead);

    if (products.length > 1) {
      var also = document.createElement("p");
      also.className = "lumen-didyoumean-bar__also";
      also.appendChild(document.createTextNode("Also try: "));
      for (var i = 1; i < Math.min(products.length, 4); i++) {
        if (i > 1) also.appendChild(document.createTextNode(" · "));
        var a = document.createElement("a");
        a.className = "lumen-didyoumean-bar__chip";
        a.href = "/products/" + products[i].handle;
        a.textContent = products[i].title;
        also.appendChild(a);
      }
      wrap.appendChild(also);
    }

    host.appendChild(wrap);
  }

  function findSearchMount() {
    var existing = document.querySelector(".lumen-didyoumean-slot");
    if (existing) return existing;

    var main =
      document.querySelector("main") ||
      document.querySelector("#MainContent") ||
      document.body;
    if (!main) return null;

    var slot = document.createElement("div");
    slot.className = "lumen-didyoumean-slot";

    // Prefer right before product results so the tip is above the fold
    var grid = main.querySelector(
      ".product-grid, .search-results, resource-list, .resource-list, facets-form + *, .collection"
    );
    if (grid && grid.parentElement) {
      grid.parentElement.insertBefore(slot, grid);
      return slot;
    }

    // Or right after the results / empty-state copy
    var texts = main.querySelectorAll("p, h1, h2, h3, .text-block, .rte, span");
    var i;
    for (i = 0; i < texts.length; i++) {
      var t = (texts[i].textContent || "").replace(/\s+/g, " ").trim();
      if (!/results found|no results found/i.test(t)) continue;
      // Skip tiny hidden template spans
      if (t.length < 12) continue;
      if (texts[i].parentElement) {
        texts[i].parentElement.insertBefore(slot, texts[i].nextSibling);
        return slot;
      }
    }

    // Fallback: top of first main section
    var section = main.querySelector(".shopify-section, .section") || main;
    section.insertBefore(slot, section.firstChild);
    return slot;
  }

  function mountFriendlyHelp() {
    var query = queryParam();
    var pathHint = "";
    if (is404Page()) {
      pathHint = decodeURIComponent(location.pathname || "")
        .split("/")
        .filter(Boolean)
        .join(" ")
        .replace(/tool |kit /g, " ");
    }

    var needSearch = isSearchPage() && searchHasNoResults();
    var need404 = is404Page();
    var resultCount = searchResultCount();
    var needTypoBar =
      isSearchPage() && !needSearch && !!norm(query) && resultCount > 0;
    if (!needSearch && !need404 && !needTypoBar) return;

    var seed = need404 ? pathHint || "glow tools" : query;
    loadCatalog(function (catalog) {
      if (!catalog.length) return;
      var picks = suggestProducts(seed, catalog, needTypoBar && !needSearch ? 3 : 4);
      if (!picks.length) {
        // fallback: popular heroes
        var heroes = ["tool-led", "tool-gua", "kit-glow-tools", "tool-ice-roller"];
        picks = catalog.filter(function (p) {
          return heroes.indexOf(p.handle) !== -1;
        });
      }
      var mountAt = findSearchMount();
      if (!mountAt) return;

      if (need404 || needSearch) {
        renderSuggestPanel(
          mountAt,
          query || pathHint,
          picks,
          need404 ? "404" : "search"
        );
        return;
      }

      // Soft tip when Shopify still returned results but the query looks mistyped
      if (needTypoBar && looksMistyped(query, picks)) {
        renderDidYouMeanBar(mountAt, query, picks);
      }
    });
  }

  function labelBareCards() {
    var cards = document.querySelectorAll("product-card, .product-card");
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector("h3, .product-card__title, [ref='productTitleLink'], .lumen-card-label")) {
        continue;
      }
      var link = card.querySelector("a.product-card__link[aria-label], a[aria-label]");
      var name = (link && link.getAttribute("aria-label")) || "";
      if (!name) continue;
      var lab = el("p", "lumen-card-label", name);
      var host =
        card.querySelector(".product-card__content") ||
        card.querySelector(".product-grid__card") ||
        card;
      host.appendChild(lab);
    }
  }

  function polish() {
    sharpenImages();
    softImages();
    revealCards();
    polishButtons();
    polishViewAll();
    polishCatalogTitle();
    mountShopCatalog();
    mountCardArrows();
    labelBareCards();
    fixMobileMenu();
    fixMobileDrawer();
    hidePoliciesChrome();
    paintPolicies();
    hideEmptyReviews();
    polishShopName();
    hideWarehouseSkus();
    syncChrome();
  }

  function schedulePolish() {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;
    requestAnimationFrame(function () {
      polish();
      busy = false;
      if (queued) {
        queued = false;
        setTimeout(schedulePolish, 120);
      }
    });
  }

  function boot() {
    markStore();
    mountHomeHero();
    polishCatalogTitle();
    mountShopCatalog();
    polishAnnouncement();
    polishShopName();
    hideWarehouseSkus();
    hidePoliciesChrome();
    paintPolicies();
    hideEmptyReviews();
    stopMediaClickScroll();
    polish();
    watchCurrency();
    watchChrome();
    watchDrawer();
    mountFriendlyHelp();
    // Hero + search can hydrate late
    if (isHomePage()) {
      setTimeout(mountHomeHero, 200);
      setTimeout(mountHomeHero, 800);
    }
    if (isSearchPage() || is404Page()) {
      setTimeout(mountFriendlyHelp, 300);
      setTimeout(mountFriendlyHelp, 900);
      setTimeout(mountFriendlyHelp, 2000);
    }
    if (window.LumenCurrency && window.LumenCurrency.refresh) {
      window.LumenCurrency.refresh();
    }
  }

  ready(boot);

  var mo = new MutationObserver(function () {
    schedulePolish();
  });
  ready(function () {
    mo.observe(document.body, { childList: true, subtree: true });
    // Keep watching longer — home sections hydrate late
    setTimeout(function () {
      mo.disconnect();
      mountCardArrows();
    }, 20000);
    // Extra passes so every product card gets arrows
    setTimeout(mountCardArrows, 500);
    setTimeout(mountCardArrows, 1500);
    setTimeout(mountCardArrows, 4000);
  });
})();
